<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          :page-title="$t('document_extra_fields')"
          :directory="$t('datatables')"
          :icon="'grid'"
        />
      </div>
      <div class="col-sm-12 col-md-6 breadcrumb-side-button">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
          <button
            type="button"
            class="btn btn-primary btn-with-shadow"
            data-toggle="modal"
            @click="openAddEditCategoryModal"
          >
            {{ $t("add_category") }}
          </button>
        </div>
      </div>
    </div>

    <app-table :id="tableId" :options="options" @action="getListAction" />

      <!-- <vue-nestable v-model="nestableItems">
    <vue-nestable-handle
      slot-scope="{ item }"
      :item="item">
      {{ item.text }}
    </vue-nestable-handle>
  </vue-nestable> -->

   <!-- <div class="row mt-3">
    <div class="col-md-6">
      <div class="card mb-4 box-shadow">
        <div class="card-header">
          <h4 class="my-0 font-weight-normal">Nestable Test</h4>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-12">
              <vue-nestable v-model="nestableItems">
                <template slot-scope="{ item }">
                  <vue-nestable-handle :item="item"> ☰ </vue-nestable-handle>
                  <span v-on:dblclick="onItemClick(item);"
                    >Item :: {{ item.text }}</span
                  >
                </template>
              </vue-nestable>
              <vue-nestable
                  v-model="nestableItems"
                  :hooks="{
                    'beforeMove': beforeMove
                  }"
                  key-prop="id"
                  children-prop="nested"
                  class-prop="class"
                >
                  <template slot-scope="{ item }">
                    <vue-nestable-handle :item="item" style="cursor: move;">
                      <h5><i class="fas fa-bars" /> <span>{{ item.text }}</span></h5> 
                    </vue-nestable-handle>                    
                  </template>
                </vue-nestable>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div> -->

    <document-fields-addmodal
      v-if="isAddEditModalActive"
      :table-id="tableId"
      :selected-url="selectedUrl"
      :category_id="category_id"
      @close-modal="closeAddEditModal"
    />

    <document-category-addmodal
      v-if="isAddEditCategoryModalActive"
      :table-id="tableId"
      :caregoryId="category_id"
      :selected-url="selectedUrl"
      @close-modal="closeAddEditCategoryModal"
    />
    <app-delete-modal
      v-if="deleteConfirmationModalActive"
      :preloader="deleteLoader"
      modal-id="demo-delete"
      @confirmed="confirmed"
      @cancelled="cancelled"
    />
   <document-fields-viewmodal
      v-if="isViewFieldsModalActive"
      :table-id="tableId"
      :selected-url="selectedUrl"
      :category_id="category_id"
      @close-modal="closeViewFieldsModal"
    />
  </div>
</template>

<script>
import CoreLibrary from "../../../../../core/helpers/CoreLibrary.js";
import * as actions from "../../../../Config/ApiUrl";
import { TableHelpers } from "../../Demo/Tables/mixins/TableHelpers";

//nestable
import Vue from 'vue'
import VueNestable from 'vue-nestable'
Vue.use(VueNestable)

export default {
  extends: CoreLibrary,
  name: "DatatableWithFilter",
  mixins: [TableHelpers],
  data() {
    return {
      isFileUploadModal:false,
      id:'',
      // nestableItems: [
      //   {
      //     id: 1,
      //     // class: 'purple-text-color',
      //     text: 'Andy'
      //   }, {
      //     id: 2,
      //     // class: 'blue-text-color',
      //     text: 'Harry',
      //     // nested: [{
      //     //   id: 2,
      //     //   text: 'David'
      //     // }]
      //   },
      //   {
      //       id: 3,
      //       text: 'David'
      //     },
      //      {
      //     id: 4,
      //     // class: 'red-text-color',
      //     text: 'Lisa'
      //   }, {
      //     id: 5,
      //     text: 'I can not be nested'
      //   }
      // ],
      category_id: 0,
      nestableItems:[],
      isViewModalActive: false,
      isAddEditCategoryModalActive: false,
      isViewFieldsModalActive:false,
      deleteLoader: false,
      isAddEditModalActive: false,
      deleteConfirmationModalActive: false,
      selectedUrl: "",
      tableId: "advance-table",
      rowData: {},
      options: {
        url: actions.DOCUMENT_CATEGORY,
        name: 'AdvanceTable',
        datatableWrapper: false,
        showHeader: true,
        columns: [
          {
            title: this.$t("category"),
            type: "custom-html",
            key: "name",
            modifier: (value) => {
              return `<span>${this.$t(value)}</span>`;
            },
          },
        ],
        actions: [
          {
            title: this.$t("edit"),
            icon: "edit",
            type: "none",
            component: "app-add-category-modal",
            modalId: "demo-add-edit-category-Modal",
          },
          {
            title: this.$t("add_subcategory"),
            icon: "plus",
            type: "none",
            component: "app-add-category-modal",
            modalId: "demo-add-edit-category-Modal",
          },
          {
            title: this.$t("add_fields"),
            icon: "plus",
            type: "none",
            component: "app-add-modal",
            modalId: "demo-add-edit-Modal",
          },
          {
            title: this.$t("view_fields"),
            icon: "eye",
            type: "none",
            modalId: "demo-view-fields-Modal",
          },
          {
              title: this.$t('delete'),
              icon: 'trash',
              type: 'none',
              component: 'app-confirmation-modal',
              modalId: 'demo-delete',
          },
        ],
        // filters: [
        //   {
        //       "title": this.$t('date'),
        //       "type": "range-picker",
        //       "key": "date",
        //       "option": ["today", "thisMonth", "last7Days", "nextYear"]
        //   },
        //   {
        //       "title": this.$t('age'),
        //       "type": "range-filter",
        //       "key": "age-range",
        //       "maxTitle": this.$t('max_age'),
        //       "minTitle": this.$t('min_age'),
        //       "sign": ""
        //   },
        //   {
        //       "title": this.$t('status'),
        //       "type": "checkbox",
        //       "key": "status",
        //       "option": [
        //           {id: 'active', value: 'Active'},
        //           {id: 'inactive', value: 'Inactive'},
        //           {id: 'invited', value: 'Invited'},
        //       ],
        //   },
        //   {
        //       "title": this.$t('gender'),
        //       "type": "radio",
        //       "key": "filter-with-gender",
        //       "option": [
        //           {id: 'male', value: 'Male'},
        //           {id: 'female', value: 'Female'},
        //           {id: 'other', value: 'Other'},
        //       ],
        //       "header": {
        //           "title": this.$t('want_to_filter_your_list'),
        //           "description": this.$t('you_can_filter_your_data_table_which_are_created_based_on_gender'),
        //       },
        //   },
        //   {
        //       "title": this.$t('search_and_select'),
        //       "type": "drop-down-filter",
        //       "key": "search select",
        //       "option": [],
        //   }
        // ],
        showFilter: false,
        showSearch: false,
        showCount: true,
        showClearFilter: false,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: "desc",
        actionType: "dropdown",
      },
    };
  },
  created() {
    this.options.columns = [...this.options.columns, this.actionObj];
  },
  methods: {
    /**
     * for open add edit modal
     */
    beforeMove ({ dragItem, pathFrom, pathTo }) {
      // Item 4 can not be nested more than one level
      
      // if (dragItem.key === 4) {
      //   return pathTo.length === 1
      // }
      // // All other items can be
      // return true
    },
    openAddEditModal() {
      this.isAddEditModalActive = true;
    },
    openAddEditCategoryModal() {
      this.category_id = 0;
      this.isAddEditCategoryModalActive = true;
    },
    /**
     * for close add edit modal
     */
    closeAddEditModal() {
      $("#demo-add-edit-Modal").modal("hide");
      this.isAddEditModalActive = false;
      this.reSetData();
    },
    closeAddEditCategoryModal() {
      $("#demo-add-edit-category-Modal").modal("hide");
      this.isAddEditCategoryModalActive = false;
      this.reSetData();
    },
    closeViewFieldsModal() {
      $("#demo-view-fields-Modal").modal("hide");
      this.isViewFieldsModalActive = false;
      this.reSetData();
    },
    openViewModal() {
      this.isViewModalActive = true;
    },
    closeViewModal() {
      $("#demo-view-Modal").modal("hide");
      this.isViewModalActive = false;
    },

    /**
     * $emit Form datatable action
     */
    getListAction(rowData, actionObj, active) {
      this.rowData = rowData;

      if (actionObj.title == "Delete") {
        this.openDeleteModal();
      } else if (actionObj.title == this.$t("edit")) {
        this.selectedUrl = `${actions.DOCUMENT_CATEGORY_SHOW}/${rowData.id}`;
        this.openAddEditCategoryModal();
      } else if (actionObj.title == this.$t("add_fields")) {
        this.category_id = rowData.id;
        this.openAddEditModal(); 
      } else if (actionObj.title == this.$t("add_subcategory")) {
        this.category_id = rowData.id;
        // this.openAddEditCategoryModal();
        this.isAddEditCategoryModalActive = true;
      } else if (actionObj.title == this.$t("view_fields")) {
        this.category_id = rowData.id;
        this.isViewFieldsModalActive = true;
      }else if (actionObj.title == "Delete") {
        this.openDeleteModal();
      }
    },
    // closeFileUploadModal() {
    //   this.isFileUploadModal = false;
    // },

    /**
     * for open confirmation modal
     */
    openDeleteModal() {
      this.deleteConfirmationModalActive = true;
    },

    /**
     * confirmed $emit Form confirmation modal
     */
    confirmed() {
      let url = `${actions.DOCUMENT_CATEGORY_DELETE}/${this.rowData.id}`;
      this.deleteLoader = true;
      this.axiosDelete(url)
        .then((response) => {
          this.deleteLoader = false;
          $("#demo-delete").modal("hide");
          this.cancelled();
          this.$toastr.s(response.data.message);
        })
        .catch(({ error }) => {
          //trigger after error
        })
        .finally(() => {
          this.$hub.$emit("reload-" + this.tableId);
        });
    },

    /**
     * cancelled $emit Form confirmation modal
     */
    cancelled() {
      this.deleteConfirmationModalActive = false;
      this.reSetData();
    },

    reSetData() {
      this.rowData = {};
      this.selectedUrl = "";
    },
    test(data) {
      alert(data);
    },
    // getdocumentCategories() {
    //   this.axiosGet(actions.DOCUMENT_CATEGORIES)
    //     .then((res) => {
    //       this.nestableItems = res.data;
    //       
    //     })
    //     .catch((error) => {
    //       this.$toastr.e(error);
    //     })
    //     .finally(() => {});
    // },
  },
  mounted() {

    // this.getdocumentCategories();

    var user_id = this.$store.state.userCompanyProfile.dataProfile.id;
    if (user_id != null) {
      this.options.url = actions.MYDOCUMENT_LIST+'?user_id=' + user_id
    }
  }
};
</script>

<style>
.blue-text-color {
  color: #415ad4;
}
.purple-text-color {
  color: #b43ceb;
}
.red-text-color {
  color: #e13a3a;
}
</style>